import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "reduxFiles/hooks";
import { responderLoader } from "services/responderLoader";

export const ResponderGuard = ({ children }: { children: React.ReactNode }) => {
  const { responder, initialized, loading } = useAppSelector(
    (state) => state.responderAuth
  );

  useEffect(() => {
    responderLoader();
  }, []);

  if (!initialized || loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="loader w-8 text-blue-700" />
      </div>
    );
  }

  if (!responder) {
    return <Navigate to="/auth/responder-login" replace />;
  }

  return <>{children}</>;
};
